export const subscriptions = [
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: () => import('./index.vue'),
    meta: {
      rule: 'SUBSCRIPTIONS',
      authRequired: true,
      title: 'general.subscriptions',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.subscriptions',
          disabled: true,
        }
      ]
    }
  },
  {
    path: '/subscriptions/add',
    name: 'AddSubscriptions',
    component: () => import('./add.vue'),
    meta: {
      rule: 'SUBSCRIPTION_EDIT',
      authRequired: true,
      title: 'subscriptions.add',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.subscriptions',
          disabled: false,
          href: '#/subscriptions'
        },
        {
          text: 'subscriptions.add',
          disabled: true,
        }
      ]
    }
  },
  {
    path: '/subscriptions/edit/:id',
    name: 'EditSubscriptions',
    component: () => import('./add.vue'),
    meta: {
      rule: 'SUBSCRIPTION_EDIT',
      authRequired: true,
      title: 'subscriptions.edit',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.subscriptions',
          disabled: false,
          href: '#/subscriptions'
        },
        {
          text: 'subscriptions.edit',
          disabled: true,
        }
      ]
    }
  }
]